import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, take, tap } from 'rxjs';
import {
    CancelationInterface,
    CancelationResponseInterface,
} from '@/core/domain/cancelation/models/cancelation.model';
import { cancelReservationUseCase } from '@/core/domain/cancelation/usecases/cancelReservation.usecase';

@Injectable({
    providedIn: 'root',
})
export class CancelationService {
    private cancelationSubject =
        new BehaviorSubject<CancelationResponseInterface | null>(null);
    cancelation$: Observable<CancelationResponseInterface | null> =
        this.cancelationSubject.asObservable();

    constructor(private cancelReservationUseCase: cancelReservationUseCase) {}

    cancelReservation(
        params: CancelationInterface,
    ): Observable<CancelationResponseInterface> {
        return this.cancelReservationUseCase.execute(params).pipe(
            take(1),
            tap((response: CancelationResponseInterface) => {
                this.cancelationSubject.next(response);
            }),
        );
    }

    clearDetailsCache(): void {
        this.cancelationSubject.next(null);
    }
}
